export const mockCartData = {
  headerPriceTitle: 'Περίληψη Παραγγελίας',
  buttonLabel: 'Ολοκλήρωση Παραγγελίας',
  finalSumDescription: 'Τελικό Σύνολο',
  replacementsTitle: 'Επιλογές Αντικατάστασης',
  replacementsSubtitle: 'Τηλεφωνική Επικοινωνία',
  footerAddText: 'Δημιουργία Λίστας',
  footerDeleteText: 'Αφαίρεση όλων',
};

export const mockCheckoutData = {
  headerPriceTitle: 'Περίληψη Παραγγελίας',
  buttonLabel: 'Ολοκλήρωση Παραγγελίας',
  finalSumDescription: 'Τελικό Σύνολο',
  buttonText: 'Αλλαγή',
  dropdownTitle: 'Επιλογή τρόπου πληρωμής',
  discountSuccess: 'Η έκπτωση εφαρμόστηκε στο καλάθι',
  selectDiscount: 'Επίλεξε δωροεπιταγή',
  points: 'πόντοι',
  selectedPoints1: 'Έχεις',
  selectedPoints2: 'πόντους',
  missingPoints: 'ακόμα',
  methods: [
    {
      name: 'Μετρητά ή POS στην παραλαβή',
      unavailable: false,
      type: 'cash',
    },
    {
      name: 'Κάρτα',
      unavailable: false,
      type: 'card',
    },
    {
      name: 'Online πληρωμή με νέα κάρτα',
      unavailable: false,
      type: 'bankTransfer',
    },
  ],
};
